import TabButton from "./TabButton";

export default TabButton